import type { AppendMessage } from '@assistant-ui/react'
import { projectDmpChatAttachment, type DmpChatTurn } from './state/dmpChatState.ts'

export function isDmpChatPrompt(prompt: string): boolean {
  return prompt.trim().length > 0
}

export function createDmpChatRetryMessage(turn: Pick<DmpChatTurn, 'prompt' | 'attachments'>): AppendMessage {
  return {
    content: [{ type: 'text', text: turn.prompt }],
    attachments: turn.attachments.map(projectDmpChatAttachment),
  } as unknown as AppendMessage
}
